export const MEDIA_DISPLAY_STATE = {
  NO_DISPLAY: 1,
  PENDING_UPLOAD: 2,
  UPLOADED: 3,
  INVALID: 4,
  RECYCLED: 5,
  REMOVED: 6,
} as const
